/*eslint no-alert:0*/
import React from "react/addons";
import Marty from "marty";
import ValidatedInput from "./ValidatedInput";
import SubmitButton from "./SubmitButton";
import Formsy from "formsy-react";
import assign from "object-assign";
import validators from "../functions/validators";
import _ from "lodash";

const SUCCESS_MESSAGE_TIMEOUT = 3000;

let timer;

let ValidatedForm = React.createClass({
    getInitialState(){
        return {
            data: assign({}, this.props.data),
            showErrors: false,
            submitting: false,
            externalErrors: null,
            pristine: true
        };
    },
    propTypes: {
        data: React.PropTypes.object,
        handleSubmit: React.PropTypes.func.isRequired,
        handleChange: React.PropTypes.func,
        confirm: React.PropTypes.string
    },
    handleChange(key, onChange) {
        return (value) => {

            let newState = {
                data: assign(this.state.data, {
                    [key]: value
                }),
                externalErrors: null,
                pristine: false
            };

            this.setState(newState);

            //Trigger individual onChange with input value
            if (onChange) {
                onChange(newState.data[key]);
            }

            //Trigger form-level onChange with all data and changed key
            if (this.props.handleChange) {
                this.props.handleChange(newState.data, key);
            }
        };
    },
    componentWillUnmount() {
        if (timer) {
            clearTimeout(timer);
        }
    },
    componentWillMount() {
        for (let validator in validators) {
            if (validators.hasOwnProperty(validator)) {
                Formsy.addValidationRule(validator, validators[validator]);

            }
        }
    },
    handleInvalidSubmit() {
        this.setState({showErrors: true});
    },
    setExternalError(message) {
        this.setState({
            externalErrors: {
                "": message
            }
        });
    },
    reset(reset, data, successMessage, keepValues) {
        if (this.isMounted()) {
            this.setState({
                successMessage,
                showErrors: false,
                submitting: false,
                pristine: true
            });
        }

        if (successMessage) {
            timer = setTimeout(this.hideSuccessMessage, SUCCESS_MESSAGE_TIMEOUT);
        }

        if (keepValues) {
            reset(data);
        } else {
            reset();
        }
    },
    invalidate(invalidate, errors) {
        this.setState({
            showErrors: true,
            submitting: false
        });

        let externalError = errors[""];

        if (externalError) {
            delete errors[""];
            this.setExternalError(externalError);
        }

        //If for some reason a hidden input is invalid set it as a form error
        _.forOwn(errors, (value, key) => {
            if (this.refs[key].props.type === "hidden") {
                this.setExternalError(value);
                delete errors[key];
            }
        });

        //Invalidate any remaining errors in the form
        invalidate(errors);
    },
    confirmedSubmit(data, reset, invalidate) {
        this.setState({
            showConfirmModal: null,
            submitting: true
        });
        this.props.handleSubmit(data, this.reset.bind(null, reset, data), this.invalidate.bind(null, invalidate));
    },
    handleValidSubmit(data, reset, invalidate) {
        if (this.props.confirm) {
            this.app.navActions.confirm(this.props.confirm, this.confirmedSubmit.bind(null, data, reset, invalidate));
        } else {
            this.confirmedSubmit(data, reset, invalidate);
        }
    },
    hideSuccessMessage() {
        this.setState({successMessage: null});
    },
    renderChildren(children) {
        return React.Children.map(children, (child) => {
            if (child) {
                if (child.type === ValidatedInput) {
                    return React.addons.cloneWithProps(child, {
                        onChange: this.handleChange(child.props.name, child.props.onChange),
                        ref: child.props.name
                    });
                } else if (child.type === SubmitButton) {
                    return React.addons.cloneWithProps(child, {
                        ref: "submit",
                        submitting: this.state.submitting
                    });
                } else if (child.props && child.props.children) {
                    return React.addons.cloneWithProps(child, {
                        children: this.renderChildren(child.props.children)
                    });
                }
            }
            return child;
        });
    },
    render() {
        let errorClass = this.state.externalErrors ? "show-external-errors" : this.state.showErrors ? "show-errors" : "";

        return (
            <Formsy.Form className={["eo-form", this.props.className, errorClass].join(" ")}
                         onValidSubmit={this.handleValidSubmit}
                         onInvalidSubmit={this.handleInvalidSubmit}
                         autoComplete={this.props.autoComplete}
                         validationErrors={this.state.externalErrors}>
                {this.renderChildren(this.props.children)}
                <ul className="eo-form-validation-errors grid-10">
                    {_.values(this.state.externalErrors).map((error, index) => {
                        return (
                            <li className="eo-form-message eo-form-validation-error" key={index}>{error}</li>
                        );
                    })}
                </ul>
                {this.state.successMessage ?
                 <p className="eo-form-message eo-form-success-message grid-10">{this.state.successMessage}</p> : null}
            </Formsy.Form>
        );
    }
});

export default Marty.createContainer(ValidatedForm);



/** WEBPACK FOOTER **
 ** ./app/utils/components/ValidatedForm.js
 **/